import { makeActionCreator } from '../../utils/redux'

export const FETCH_INIT = 'FETCH_INIT'
export const fetchInit = makeActionCreator(FETCH_INIT)

export const INIT_FETCHED = 'INIT_FETCHED'
export const initFetched = makeActionCreator(INIT_FETCHED, 'isSuccess')
